<template>
  <FormItem :label="model.variable.label" :inline="inline">
    <Input type="text" v-model="model.val"></Input>
  </FormItem>
</template>

<script>
export default {
  name: 'datatime-element',
  data: function () {
    return {
      newVal: this.val.val
    }
  },
  // watch: {
  //   'val': function () {
  //     this.newVal = this.val.val
  //   }
  // },
  props: ['model', 'inline'],
  methods: {
    editVal: function () {
      this.$emit('editVal', this.model, this.newVal)
    }
  }
}
</script>
